/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/**
 * Factory for creating Crown communication data structure.
 */
export class CrownCallFactory {
  static createDataSetViewId(crownHdl, viewID) {
    return {
      handle: {
        type: 'handle',
        id: crownHdl
      },
      id: viewID
    };
  }

  static createDataRegisterEvent(eventname, crownHdl) {
    const call = {
      eventname
    };

    if (crownHdl != null) {
      call.handle = {
        type: 'handle',
        id: crownHdl
      };
    }

    return call;
  }

  static createFunctionCall(func, data = {}, options = {}) {
    // tslint:disable-line:no-any
    return {
      header: {
        type: 'FunctionCall',
        clientId: 0,
        function: func
      },
      data,
      options
    };
  }

  static createOptionMessageQueue(priority, maxSize, discardIfFull) {
    return {
      queue: {
        priority,
        maxSize,
        discardIfFull
      }
    };
  }

}
//# sourceMappingURL=CrownCallFactory.js.map